import React from 'react';
import {Link} from 'react-router-dom';
import Layout from '../../Layout/Layout';
import MediaQuery from 'react-responsive';

import "./style.scss";

import comingSoonImg from "../../assets_global/images/coming-soon.png";

class ComingSoonPg extends React.Component {

render() {
  return (
    <>
      <Layout pageCurrent="coming-soon">
        <div className="container">
          <img src={comingSoonImg} alt="coming soon" />
        </div>
      </Layout>
    </>
  )
}
}

export default ComingSoonPg;